import Vue from 'vue';
import Component from 'vue-class-component';
import {
    ApplicationViewModel, RequirementValueViewModel, RequirementViewModel, ApplicationActions
} from "@/api-client";
import {Prop} from "vue-property-decorator";
@Component
export default class RequirementSummary extends Vue {
    @Prop({required: true})
    requirement!: RequirementViewModel;
    @Prop({required: true})
    application!: ApplicationViewModel;
    @Prop({required: true, default: null})
    requirementValue!: RequirementValueViewModel | null;
    @Prop({required: true})
    seafarerId!: string;
    @Prop({required: true})
    actions!: ApplicationActions;


}
